const STATISTIC_TYPES = {
    "平均數": {
        value: 3,
        label: "平均數",
    },
    "中位數": {
        value: 4,
        label: "中位數",
    },
   "百分比": {
    value: 1,
    label: "百分比",
   },
   "實際數": {
    value: 2,
    label: "計數",
   },
}

export const ALL_STATISTICS_TYPES = [
    STATISTIC_TYPES["平均數"],
    STATISTIC_TYPES["中位數"],
    STATISTIC_TYPES["百分比"],
    STATISTIC_TYPES["實際數"],
]

// input = 1
// output = {
//     value: 1,
//     label: "百分比",
// }

export const FIND_STATISTIC_TYPE_BY_VALUE = (value) => {
    let foundType = ALL_STATISTICS_TYPES.find(type => type.value === value);

    return foundType ? foundType : null;
}

export default STATISTIC_TYPES;
